module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v(_vm._s(_vm.$t('notification.seen')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "18%"
    }
  }, [_vm._v(_vm._s(_vm.$t('notification.received')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "73%"
    }
  }, [_vm._v(_vm._s(_vm.$t('notification.notification')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "4%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.notifications), function(notification) {
    return _c('notification-list-row', {
      key: notification.uid,
      attrs: {
        "notification": notification
      }
    })
  })), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notifications.length >= 10),
      expression: "notifications.length >= 10"
    }]
  }, [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v(_vm._s(_vm.$t('notification.seen')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "18%"
    }
  }, [_vm._v(_vm._s(_vm.$t('notification.received')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "73%"
    }
  }, [_vm._v(_vm._s(_vm.$t('notification.notification')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "4%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-465f2b2a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notifications/NotificationListTable.vue
// module id = 510
// module chunks = 0